import RichText from '../RichText';
import SingleLineText from '../SingleLineText';

const propTypes = {
	title: SingleLineText.PropTypes,
	description: RichText.PropTypes,
};

export default propTypes;
